import { render, staticRenderFns } from "./ExcelExportAsistencia.vue?vue&type=template&id=23f55c02"
import script from "./ExcelExportAsistencia.vue?vue&type=script&lang=js"
export * from "./ExcelExportAsistencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports